import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const BulkInventoryAdjustments = {
	name: NAME,
	apiProvider,
	router,
};